import { render, staticRenderFns } from "./tlQaInfo.vue?vue&type=template&id=2f9ea007&scoped=true&"
import script from "./tlQaInfo.vue?vue&type=script&lang=js&"
export * from "./tlQaInfo.vue?vue&type=script&lang=js&"
import style0 from "./tlQaInfo.vue?vue&type=style&index=0&id=2f9ea007&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ea007",
  null
  
)

export default component.exports